import { FC } from 'react'
import styled, { css } from 'styled-components'
import { Tiny2 } from '@/components/atoms/typography'
import { ProductLabelType, TextLabel } from '@/network/graphql.g'
import { ITheme } from '@/theme/interfaces/ITheme'
import { validFor } from '@/theme/validFor'

type ProductLabelProps = {
  label: TextLabel
  isDetail?: boolean
} & Rest

const ProductLabel: FC<ProductLabelProps> = ({ label, isDetail, ...rest }) => {
  const props = {
    type: label?.type,
    'data-testid': 'productLabel'
  }

  if (label?.type === ProductLabelType.FreeShipping) {
    return null
  }

  return label ? (
    <>
      {isDetail ? (
        <DetailTextLabel {...props} {...rest}>
          {label?.title}
        </DetailTextLabel>
      ) : (
        <ListingTextLabel {...props} {...rest}>
          {label?.title}
        </ListingTextLabel>
      )}
    </>
  ) : null
}

export default ProductLabel

const BaseTextLabel = css`
  font-weight: bold;
  background-color: ${({ type, theme }) => getBackgroundColor(type, theme)};
  color: ${({ type, theme }) => getColor(type, theme)};
  text-align: center;
  margin: 0 0 5px 0;
  padding: 1px 3px 0px 3px;
  line-height: 1.42857143;
  border-radius: ${(props) => props.theme.borderRadius}px;
  text-transform: uppercase;
  display: inline-block;
  font-size: 10px;
  width: ${({ type }) =>
    type === ProductLabelType.FreeShipping ? 'auto' : ' min-content'};
  ${validFor.desktop`  
     font-size: 12px;
     padding: 2px 5px 2px;
  `}
`

export const DetailTextLabel = styled(Tiny2)`
  ${BaseTextLabel}
  padding: 2px 3px 0px 3px;
  font-size: 16px;
`

export const ListingTextLabel = styled(Tiny2)`
  ${BaseTextLabel}
`

const getColor = (type: ProductLabelType, theme: ITheme): string => {
  switch (type) {
    case ProductLabelType.Discount:
      return theme.colors.discountLabelColor
    case ProductLabelType.FreeShipping:
      return theme.colors.freeShippingLabelColor
    default:
      return theme.colors.onBackground
  }
}

const getBackgroundColor = (type: ProductLabelType, theme: ITheme): string => {
  switch (type) {
    case ProductLabelType.Discount:
      return theme.colors.discountLabelBackgroundColor
    case ProductLabelType.FreeShipping:
      return theme.colors.freeShippingLabelBackgroundColor
    default:
      return theme.colors.background
  }
}
